import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-bottom-footer',
  standalone: true,
  templateUrl: './bottom-footer.component.html',
  styleUrl: './bottom-footer.component.scss',
  imports: [RouterLink]
})
export class BottomFooterComponent {

}
